interface CurrencyOptionType {
	unit?: string
	unitPosition?: 'left' | 'right'
}

export const Currency = {
	get: (value: number, option?: CurrencyOptionType) => {
		const unit = option?.unit ?? ''
		const unitPosition: 'left' | 'right' = option?.unitPosition ?? 'right'
		const tempValue = `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
		const res = (() => {
			if (unit === '') {
				return tempValue
			} else {
				if (unitPosition === 'left') {
					return `${unit} ${tempValue}`
				} else {
					return `${tempValue} ${unit}`
				}
			}
		})()

		return res
	},
}

/**
 * 고객 화면의 가격표 (2026-09-15, 가격 구조 결정).
 *
 * 딱 떨어지는 값에는 `.00` 을 붙이지 않는다 — `$1,000` · `$799`. 센트는 값이 실제로
 * 센트를 가질 때만 나온다(`$12.50`). `.00` 은 영수증의 문법이고, 가격표에서는 값을
 * 읽는 속도만 늦춘다. 장바구니·결제의 합계는 거래 문서라 이 함수를 쓰지 않는다.
 */
export const formatUsd = (value: number): string =>
	value.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
		maximumFractionDigits: 2,
	})

/**
 * 거래 문서(장바구니 합계·결제·주문내역)의 금액 표기. 서버 인보이스·메일과 같은 문법이다 —
 * USD `$799` (센트는 값이 있을 때만 `$12.50`), KRW 는 정수(`₩1,199,000`).
 */
export const formatAmount = (currency: string, value: number): string =>
	currency === 'KRW'
		? Math.round(value).toLocaleString('en-US', {
				style: 'currency',
				currency: 'KRW',
				maximumFractionDigits: 0,
		  })
		: value.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD',
				// 센트를 보이지 않는다 (사용자 결정 2026-09-16). 값이 실제로 센트를 가질 때만
				minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
				maximumFractionDigits: 2,
		  })
